const clipTextBase = ({
    ctx,
    content,
    line,
    ellipsis,
    prefixWidth,
    addonWidth,
    wrapWidth,
    fontStyle,
    fontVariant,
    fontWeight,
    fontSize,
    lineHeight,
    fontFamily,
    emoji,
    emojiWidth,
    debug,
}) => {
    // 设置canvas上下文的字体
    const ctxFont = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}`
    ctx.font = ctxFont;

    if (debug) {
        console.log('\n');
        console.log('--- 文字裁剪开始 ---');
        console.log('原始文本为：', content);
        console.log('凤凰表情图片宽度：', emojiWidth);
        console.log('字体信息 ${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}：', ctxFont)
    }

    // 字符分组（主要目的是分出凤凰表情）
    const charList = [];

    let charIndex = 0;

    while (charIndex < content.length) {
        const currentChar = content[charIndex];

        if (currentChar === '[') {
            let tempIndex = charIndex + 1;
            let hasRightPair = false;

            while (tempIndex < content.length) {
                if (content[tempIndex] === ']') {
                    hasRightPair = true;
                    tempIndex += 1;

                    break;
                } else {
                    tempIndex += 1;
                }
            }

            const tempEmoji = content.slice(charIndex, tempIndex);

            if (hasRightPair && emoji.find(item => item.code === tempEmoji)) {
                charList.push(tempEmoji);

                charIndex = tempIndex;
            } else {
                charList.push(currentChar);
                charIndex += 1;
            }
        } else {
            charList.push(currentChar);
            charIndex += 1;
        }
    }

    if (debug) {
        console.log('分字：', charList);
    }

    // 分词
    const wordList = [];

    for (let i = 0; i < charList.length; i++) {
        const prev = charList[i - 1];
        const current = charList[i];

        const postPunctuation = /[!),.:;?\]}¨·ˇˉ―‖’”…∶、。〃々〉》」』】〕〗！＂＇），．：；？］｀｜｝～￠]/;
        const leadingPunctuation = /[([{·‘“〈《「『【〔〖（．［｛￡￥]/;
        const westernLanguage = /[A-Za-z\d]/;

        if (current.length <= 1) {
            if (prev && prev.length <= 1) {
                if (
                    postPunctuation.test(current) ||
                    leadingPunctuation.test(prev) ||
                    current === ' ' ||
                    (westernLanguage.test(prev) && westernLanguage.test(current))
                ) {
                    wordList[wordList.length - 1].text += current;
                } else {
                    wordList.push({ type: 'word', text: current });
                }
            } else {
                wordList.push({ type: 'word', text: current });
            }
        } else {
            wordList.push({ type: 'emoji', text: current });
        }
    }

    if (debug) {
        console.log('分词：', wordList);
    }

    const lineList = [];
    let wordIndex = 0;
    let overflow = true;

    for (let i = 0; i < line; i++) {
        let currentWordList = [];
        const isFirstLine = i === 0;
        const isLastLine = i >= line - 1;
        let startLineWidth = isFirstLine ? prefixWidth : 0;
        let endLineWord = '';
        let loopFlag = 1;
        let initWordIndex = wordIndex;

        while (loopFlag > 0) {
            let isWordEnd = true;

            for (let i = wordIndex; i < wordList.length; i++) {
                const currentWord = wordList[wordIndex];

                if (currentWord.text === '\n') {
                    currentWordList.push(currentWord);
                    wordIndex += 1;

                    if (wordList[wordIndex + 1]) {
                        isWordEnd = false;
                    }

                    break;
                }

                const currentTextList = [];
                let currentEmojiWidth = 0;

                [...currentWordList, currentWord].forEach(item => {
                    const { type, text } = item;

                    if (type === 'word') {
                        currentTextList.push(text);
                    } else if (type === 'emoji') {
                        currentEmojiWidth += emojiWidth;
                    }
                });

                const currentStr = currentTextList.join('') + endLineWord;
                const currentWidth = startLineWidth + ctx.measureText(currentStr).width + currentEmojiWidth;

                if (currentWidth <= wrapWidth) {
                    currentWordList.push(currentWord);
                    wordIndex += 1;
                } else {
                    isWordEnd = false;

                    break;
                }
            }

            if (isLastLine && loopFlag === 1 && !isWordEnd) {
                currentWordList = [];
                endLineWord = ellipsis;
                startLineWidth += addonWidth
                loopFlag = 2;
                wordIndex = initWordIndex;
            } else {
                if (loopFlag === 2) {
                    if(currentWordList[currentWordList.length - 1].text !== '\n') {
                        currentWordList.push({ type: 'word', text: ellipsis });
                    }
                }

                loopFlag = 0;
            }
        }

        if (debug) {
            console.log('单个分行：', currentWordList);
        }

        lineList.push(currentWordList.map(item => item.text).join(''));

        if (wordIndex >= wordList.length) {
            overflow = false;

            break;
        }
    }

    const finalText = overflow ? lineList.join('') : content;

    if (debug) {
        console.log('裁剪后的文本：', finalText);
        console.log('是否超出：', overflow);
        console.log('文本行数：', lineList.length);
        console.log('--- 文字裁剪结束 ---');
        console.log('\n');
    }

    return { text: finalText, overflow, line: lineList.length };
};

export default clipTextBase;
